import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classnames from 'classnames';
import type { AdItem } from '@sbt-web/network/types';
import AdDescription from '../../AdDescription';
import type { SectionProps } from './section';
interface Props {
  ad: AdItem;
}
const AdDescriptionSection: FC<Props & SectionProps> = t0 => {
  const $ = _c(9);
  const {
    ad,
    classes: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  let t3;
  if ($[2] !== classes) {
    t3 = classnames(...classes);
    $[2] = classes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== ad) {
    t4 = <AdDescription ad={ad} />;
    $[4] = ad;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <section className={t3}>{t4}</section>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default AdDescriptionSection;